

import React, { useState } from "react";
import BaseModal from "../../../components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";

export default function LoadWalletAddNewRequest({
  show,
  onClose,
  userData,
  title,
}) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();

  

  const validateForm = () => {
    const depositBank = document.querySelector(
      'select[name="depositBank"]'
    ).value;
    const amount = document.getElementById("amount").value.trim();
    const paymentMode = document.querySelector(
      'select[name="paymentMode"]'
    ).value;
    const payDate = document.getElementById("payDate").value;
    const refNo = document.getElementById("refNo").value.trim();
    const paySlip = document.getElementById("paySlip").files[0];
    const remark = document.getElementById("remark").value.trim();

    let newErrors = {};

    // Deposit Bank validation
    if (!depositBank) {
      newErrors.depositBank = "Please select a deposit bank.";
    }

    // Amount validation
    if (!amount) {
      newErrors.amount = "Amount is required.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(amount)) {
      newErrors.amount = "Amount must be a valid number.";
    } else {
      const numAmount = parseFloat(amount);
      if (numAmount <= 0) {
        newErrors.amount = "Amount must be greater than 0.";
      } else if (numAmount > 500000) {
        newErrors.amount = "Amount cannot exceed 500,000.";
      }
    }

    // Payment Mode validation
    if (!paymentMode) {
      newErrors.paymentMode = "Please select a payment mode.";
    }

    // Pay Date validation
    if (!payDate) {
      newErrors.payDate = "Pay date is required.";
    } else {
      const selectedDate = new Date(payDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate > today) {
        newErrors.payDate = "Pay date cannot be in the future.";
      }
    }

    // Reference Number validation
    if (!refNo) {
      newErrors.refNo = "Reference number is required.";
    } else if (refNo.length < 5) {
      newErrors.refNo = "Reference number must be at least 5 characters.";
    } else if (refNo.length > 50) {
      newErrors.refNo = "Reference number cannot exceed 50 characters.";
    }

    // Pay Slip validation
    if (!paySlip) {
      newErrors.paySlip = "Pay slip is required.";
    } else {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      if (!allowedTypes.includes(paySlip.type)) {
        newErrors.paySlip = "Pay slip must be a JPG, PNG, or PDF file.";
      } else if (paySlip.size > 5 * 1024 * 1024) {
        // 5MB
        newErrors.paySlip = "Pay slip file size cannot exceed 5MB.";
      }
    }

    // Remark validation (optional but has length limit)
    if (remark && remark.length > 500) {
      newErrors.remark = "Remark cannot exceed 500 characters.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const depositBank = document.querySelector(
      'select[name="depositBank"]'
    ).value;
    const amount = document.getElementById("amount").value.trim();
    const paymentMode = document.querySelector(
      'select[name="paymentMode"]'
    ).value;
    const payDate = document.getElementById("payDate").value;
    const refNo = document.getElementById("refNo").value.trim();
    const paySlip = document.getElementById("paySlip").files[0];
    const remark = document.getElementById("remark").value.trim();

    const formData = new FormData();
    formData.append("depositBank", depositBank);
    formData.append("amount", amount);
    formData.append("paymentMode", paymentMode);
    formData.append("payDate", payDate);
    formData.append("refNo", refNo);
    formData.append("paySlip", paySlip);
    formData.append("remark", remark);
    formData.append("action", "ADDUpdate");
    formData.append("userid", userid);

    try {
      const response = await fetch(
        "https://pro.mokshiq.in/load_wallet_request",
        {
          method: "POST",
           headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
          body: formData,
        }
      );

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
        return;
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Request submitted successfully!", "success");
        onClose();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and decimal point
    const numericValue = value.replace(/[^0-9.]/g, "");

    // Prevent multiple decimal points
    const parts = numericValue.split(".");
    if (parts.length > 2) {
      e.target.value = parts[0] + "." + parts.slice(1).join("");
      return;
    }

    // Limit decimal places to 2
    if (parts[1] && parts[1].length > 2) {
      e.target.value = parts[0] + "." + parts[1].substring(0, 2);
      return;
    }

    e.target.value = numericValue;

    // Clear error when user starts typing
    if (errors.amount) {
      setErrors((prev) => ({ ...prev, amount: null }));
    }
  };

  const clearFieldError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prev) => ({ ...prev, [fieldName]: null }));
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={title}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        {
          label: "Submit Request",
          className: "btn-primary",
          onClick: handleSave,
        },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          {/* Deposit Bank */}
          <div className="col-md-6">
            <label className="form-label">
              Deposit Bank <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${
                errors.depositBank ? "is-invalid" : ""
              }`}
              name="depositBank"
              onChange={() => clearFieldError("depositBank")}
            >
              <option value="">-- Select Bank --</option>
              {userData?.bankData?.map((bank) => (
                <option key={bank.id} value={bank.id}>
                  {bank.accon}
                </option>
              ))}
            </select>
            {errors.depositBank && (
              <div className="text-danger mt-1 f-s-12">
                {errors.depositBank}
              </div>
            )}
          </div>

          {/* Amount */}
          <div className="col-md-6">
            <label className="form-label" htmlFor="amount">
              Amount <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <span className="input-group-text">₹</span>
              <input
                className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                id="amount"
                name="amount"
                type="text"
                placeholder="Enter amount"
                onChange={handleAmountChange}
                onKeyPress={(e) => {
                  if (
                    !/[0-9.]/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Delete" &&
                    e.key !== "Tab"
                  ) {
                    e.preventDefault();
                  }
                }}
                inputMode="decimal"
              />
            </div>
            {errors.amount && (
              <div className="text-danger mt-1 f-s-12">{errors.amount}</div>
            )}
          </div>

          {/* Payment Mode */}
          <div className="col-md-6">
            <label className="form-label">
              Payment Mode <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${
                errors.paymentMode ? "is-invalid" : ""
              }`}
              name="paymentMode"
              onChange={() => clearFieldError("paymentMode")}
            >
              <option value="">-- Select Payment Mode --</option>
              <option value="IMPS">IMPS</option>
              <option value="NEFT">NEFT</option>
              <option value="RTGS">RTGS</option>
              <option value="UPI">UPI</option>
              <option value="Net Banking">Net Banking</option>
            </select>
            {errors.paymentMode && (
              <div className="text-danger mt-1 f-s-12">
                {errors.paymentMode}
              </div>
            )}
          </div>

          {/* Pay Date */}
          <div className="col-md-6">
            <label className="form-label" htmlFor="payDate">
              Pay Date <span className="text-danger">*</span>
            </label>
            <input
              className={`form-control ${errors.payDate ? "is-invalid" : ""}`}
              id="payDate"
              name="payDate"
              type="date"
              max={new Date().toISOString().split("T")[0]}
              onChange={() => clearFieldError("payDate")}
            />
            {errors.payDate && (
              <div className="text-danger mt-1 f-s-12">{errors.payDate}</div>
            )}
          </div>

          {/* Reference Number */}
          <div className="col-md-6">
            <label className="form-label" htmlFor="refNo">
              Reference Number <span className="text-danger">*</span>
            </label>
            <input
              className={`form-control ${errors.refNo ? "is-invalid" : ""}`}
              id="refNo"
              name="refNo"
              type="text"
              placeholder="Enter reference number"
              maxLength="50"
              onChange={() => clearFieldError("refNo")}
            />
            {errors.refNo && (
              <div className="text-danger mt-1 f-s-12">{errors.refNo}</div>
            )}
          </div>

          {/* Pay Slip */}
          <div className="col-md-6">
            <label className="form-label" htmlFor="paySlip">
              Pay Slip <span className="text-danger">*</span>
            </label>
            <input
              className={`form-control ${errors.paySlip ? "is-invalid" : ""}`}
              id="paySlip"
              name="paySlip"
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={() => clearFieldError("paySlip")}
            />
            {errors.paySlip && (
              <div className="text-danger mt-1 f-s-12">{errors.paySlip}</div>
            )}
            <small className="form-text text-muted">
              Upload JPG, PNG, or PDF (Max 5MB)
            </small>
          </div>

          {/* Remark */}
          <div className="col-12">
            <label className="form-label" htmlFor="remark">
              Remark
            </label>
            <textarea
              className={`form-control ${errors.remark ? "is-invalid" : ""}`}
              id="remark"
              name="remark"
              rows="3"
              placeholder="Enter any additional remarks (optional)"
              maxLength="500"
              onChange={() => clearFieldError("remark")}
            />
            {errors.remark && (
              <div className="text-danger mt-1 f-s-12">{errors.remark}</div>
            )}
            <small className="form-text text-muted">
              Optional - Maximum 500 characters
            </small>
          </div>
        </form>
      </div>
    </BaseModal>
  );
}